import ThemeProvider from "src/shared/services/theme/theme.provider";
import ContainerProvider from "src/shared/services/container/container.provider";
import QueryProvider from "src/shared/services/query/client/client.provider";
import NotificationProvider from "src/shared/services/notification/notification.provider";
import { ReactNode } from "react";
import { MuiLocaleProvider } from "../theme";

interface ContainerProviderProps {
    children: ReactNode;
}

function WrapperProvider(props: ContainerProviderProps) {
    // * Props
    const { children } = props;

    // * Render
    return (
        <ContainerProvider>
            <QueryProvider>
                <ThemeProvider>
                    <MuiLocaleProvider>
                        <NotificationProvider>{children}</NotificationProvider>
                    </MuiLocaleProvider>
                </ThemeProvider>
            </QueryProvider>
        </ContainerProvider>
    );
}

export default WrapperProvider;
